// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH_LOGIN: `${API_BASE_URL}/api/auth/login`,
  AUTH_REGISTER: `${API_BASE_URL}/api/auth/register`,
  AUTH_ME: `${API_BASE_URL}/api/auth/me`,
  
  // User endpoints
  USERS_ME: `${API_BASE_URL}/api/users/me`,
  USERS_COMPANY: (companyId) => `${API_BASE_URL}/api/users/company/${companyId}/users`,
  USERS_COMPANY_CREATE: (companyId) => `${API_BASE_URL}/api/users/company/${companyId}/create`,
  USERS_UPDATE: (userId) => `${API_BASE_URL}/api/users/${userId}`,
  USERS_DELETE: (userId) => `${API_BASE_URL}/api/users/${userId}`,
  USERS_REACTIVATE: (userId) => `${API_BASE_URL}/api/users/${userId}/reactivate`,
  USERS_DELETE_PERMANENT: (userId) => `${API_BASE_URL}/api/users/${userId}/permanent`,
  
  // Requirements endpoints
  REQUIREMENTS_PROCESS: `${API_BASE_URL}/api/requirements/process`,
  REQUIREMENTS_USER_LIST: (userId) => `${API_BASE_URL}/api/requirements/user/${userId}/list`,
  REQUIREMENTS_VIEW: (id) => `${API_BASE_URL}/api/requirements/${id}/view`,
  REQUIREMENTS_SCREENING_VIEW: (id) => `${API_BASE_URL}/api/requirements/${id}/screening-view`,
  REQUIREMENTS_UPDATE: (id) => `${API_BASE_URL}/api/requirements/${id}`,
  REQUIREMENTS_UPDATE_SCREENING: (id) => `${API_BASE_URL}/api/requirements/${id}/update-screening`,
  REQUIREMENTS_APPROVE: (id) => `${API_BASE_URL}/api/requirements/${id}/approve`,
  REQUIREMENTS_DELETE: (id) => `${API_BASE_URL}/api/requirements/${id}`,
  REQUIREMENTS_STATUS: (id) => `${API_BASE_URL}/api/requirements/${id}/status`,
  REQUIREMENTS_COMPANY_GROUPED: (companyId) => `${API_BASE_URL}/api/requirements/company/${companyId}/grouped`,
  
  // Meetings endpoints
  MEETINGS_MY_MEETINGS: `${API_BASE_URL}/api/meetings/my-meetings`,
  MEETINGS_DETAIL: (meetingId) => `${API_BASE_URL}/api/meetings/${meetingId}`,
  MEETINGS_UPDATE: (meetingId, params) => `${API_BASE_URL}/api/meetings/${meetingId}${params ? '?' + params : ''}`,
  MEETINGS_JOIN_TOKEN: (meetingId) => `${API_BASE_URL}/api/meetings/${meetingId}/join-token`,
  MEETINGS_COMPLETE: (meetingId) => `${API_BASE_URL}/api/meetings/${meetingId}/complete`,
  MEETINGS_STATUS: (meetingId) => `${API_BASE_URL}/api/meetings/${meetingId}/status`,
  MEETINGS_SCHEDULE: `${API_BASE_URL}/api/meetings/schedule`,
  MEETINGS_HIRING_MANAGERS: `${API_BASE_URL}/api/meetings/hiring-managers`,
  
  // Companies endpoints
  COMPANIES_LIST: `${API_BASE_URL}/api/companies/list`,
  COMPANIES_CREATE: `${API_BASE_URL}/api/companies/create`,
  COMPANIES_UPDATE: (companyId) => `${API_BASE_URL}/api/companies/${companyId}`,
  COMPANIES_DELETE: (companyId) => `${API_BASE_URL}/api/companies/${companyId}`,

  // Job-board integrations (company-level API keys)
  INTEGRATIONS_JOB_BOARDS: (companyId) => `${API_BASE_URL}/api/integrations/company/${companyId}/job-boards`,
  INTEGRATIONS_JOB_BOARD: (companyId, board) => `${API_BASE_URL}/api/integrations/company/${companyId}/job-boards/${board}`,
  
  // File upload endpoints
  UPLOADS_BASE: `${API_BASE_URL}/uploads`,
  UPLOADS_COMPANY_LOGO: (companyId) => `${API_BASE_URL}/uploads/companies/${companyId}/logo`,
  
  // Notifications endpoints
  NOTIFICATIONS_LIST: `${API_BASE_URL}/api/notifications/list`,
  NOTIFICATIONS_MARK_READ: (notificationId) => `${API_BASE_URL}/api/notifications/${notificationId}/read`,
  
  // Health check
  HEALTH: `${API_BASE_URL}/health`,
  
  // API Documentation
  DOCS: `${API_BASE_URL}/docs`
};

// Helper function to get full URL for uploads
export const getUploadUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  const cleanPath = path.replace(/\\/g, '/');
  return `${API_ENDPOINTS.UPLOADS_BASE}/${cleanPath}`;
};

// Export base URL for any custom endpoints
export { API_BASE_URL };